import { render, staticRenderFns } from "./AuthorizationField.vue?vue&type=template&id=a472b440"
import script from "./AuthorizationField.vue?vue&type=script&lang=js"
export * from "./AuthorizationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports